module.exports = __webpack_public_path__ + "static/media/linkDividingSubImg.55fc71a1.png";